<script lang="ts" setup>
import Link1 from '@/components/Button/Link1.vue'
import type { IInfoBlock } from '@/utils/types'

const props = defineProps({
  data: {
    type: Array as PropType<Array<IInfoBlock>>,
    default: []
  }
})
const refZonezoneBox2 = ref()

const isShowPic: Ref<boolean> = ref(false)
const handleScroll = () => {
  let top = refZonezoneBox2.value.getBoundingClientRect().top
  let distance = window.innerHeight / 2
  if (top < distance) {
    isShowPic.value = true
  }
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <section class="zonezoneBox2" ref="refZonezoneBox2">
    <div class="zonezoneBox2__card zonezoneBox2__card1">
      <figure class="zonezoneBox2__pic zonezoneBox2__card1__pic square__pic h__pic" :class="{ isShow: isShowPic }">
        <Nimg :src="data[0].image_lg?.link" :alt="data[0].image_lg?.alt" :title="data[0].image_lg?.title" />
      </figure>
      <div class="zonezoneBox2__title zonezoneBox2__card1__title">{{ data[0].title }}</div>
      <div class="zonezoneBox2__subtitle zonezoneBox2__card1__subtitle">{{ data[0].title_en }}</div>
      <div class="zonezoneBox2__card1__box">
        <Link1 :to="data[0].url" class="zonezoneBox2__link">即刻報名</Link1>
        <div class="zonezoneBox2__text zonezoneBox2__card1__text">
          {{ data[0].description }}
        </div>
      </div>
    </div>
    <div class="zonezoneBox2__card zonezoneBox2__card2">
      <div class="zonezoneBox2__subtitle zonezoneBox2__card2__subtitle zonezoneBox2__card2__subtitle-pc">
        {{ data[1].title_en }}
      </div>
      <div class="zonezoneBox2__card2__box">
        <figure class="zonezoneBox2__pic zonezoneBox2__card2__pic square__pic h__pic" :class="{ isShow: isShowPic }">
          <Nimg :src="data[1].image_lg?.link" :alt="data[1].image_lg?.alt" :title="data[1].image_lg?.title" />
        </figure>
        <div class="zonezoneBox2__card2__box__right">
          <div class="zonezoneBox2__subtitle zonezoneBox2__card2__subtitle zonezoneBox2__card2__subtitle-mobile">
            {{ data[1].title_en }}
          </div>
          <div class="zonezoneBox2__title zonezoneBox2__card2__title" v-html="data[1].title">
          </div>
          <div class="zonezoneBox2__text zonezoneBox2__card2__text">
            {{ data[1].description }}
          </div>
          <Link1 :to="data[1].url" class="zonezoneBox2__link">即刻報名</Link1>
        </div>
      </div>
    </div>
    <div class="zonezoneBox2__card zonezoneBox2__card1 zonezoneBox2__card3">
      <figure class="zonezoneBox2__pic zonezoneBox2__card1__pic square__pic h__pic" :class="{ isShow: isShowPic }">
        <Nimg :src="data[2].image_lg?.link" :alt="data[2].image_lg?.alt" :title="data[2].image_lg?.title" />
      </figure>
      <div class="zonezoneBox2__title zonezoneBox2__card1__title" v-html="data[2].title">
      </div>
      <div class="zonezoneBox2__subtitle zonezoneBox2__card1__subtitle">{{ data[2].title_en }}</div>
      <div class="zonezoneBox2__card1__box">
        <Link1 :to="data[2].url" class="zonezoneBox2__link">即刻報名</Link1>
        <div class="zonezoneBox2__text zonezoneBox2__card1__text">
          {{ data[2].description }}
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.zonezoneBox2 {
  color: #fff;
  margin-bottom: toRem(130);

  @include min-media(991) {
    display: grid;
    grid-template-areas:
      'a a a a a a . . . . . .'
      'a a a a a a b b b b b b'
      '. . . . . . b b b b b b'
      '. . c c c c c c . . . .'
      '. . c c c c c c . . . .';
    grid-auto-columns: 1fr;
    grid-template-rows: 1fr;
    column-gap: toRem(24);
  }

  @include max-media(990) {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: toRem(480);
    margin-left: auto;
    margin-right: auto;
    margin-bottom: toRem(50);
  }

  &__title {
    font-size: toRem(20);
    font-weight: 500;
  }

  &__subtitle {
    // font-size: toRem(80);
    font-size: 5.6vw;
    font-family: $font-TextaAlt;
    font-weight: 500;
    opacity: 0.3;
    line-height: 80%;

    @include max-media(990) {
      font-size: toRem(36);
    }
  }

  &__pic {
    background-color: #282828;

    @include max-media(990) {
      margin-bottom: toRem(25);
    }
  }

  &__card {
    @include max-media(990) {
      margin-bottom: toRem(55);
    }
  }

  &__link {
    color: #fff;
  }

  &__card1 {
    @include min-media(991) {
      @include grid(12, 12);
      // grid-column: 1 / span 5;
      grid-area: a;
    }

    @include max-media(990) {
      grid-column: 1 / span 4;
      display: flex;
      flex-direction: column;
    }

    &__pic {
      border-radius: toRem(500) toRem(500) 0 0;
      grid-column: 1 / span 7;
      overflow: hidden;

      @include max-media(990) {
        order: 1;
      }
    }

    &__title {
      grid-column: 8 / span 4;
      margin-top: auto;

      @include max-media(990) {
        order: 3;
        margin-bottom: toRem(3);
      }
    }

    &__subtitle {
      grid-column: 1 / span 12;

      @include max-media(990) {
        order: 2;
      }
    }

    &__box {
      display: flex;
      grid-column: 1 / span 12;
      margin-top: toRem(19);

      @include max-media(990) {
        flex-direction: column-reverse;
        order: 4;
      }
    }

    &__text {
      max-width: 300px;
      margin-left: toRem(18);

      @include max-media(990) {
        margin-left: 0;
        margin-bottom: toRem(20);
      }
    }
  }

  &__card2 {
    @include min-media(991) {
      @include grid(12, 12);
      grid-area: b;
      margin-top: -20%;
    }

    @include max-media(990) {
      display: flex;
      flex-direction: column;
    }

    &__subtitle {
      @include min-media(991) {
        grid-column: 1 / span 12;
      }

      &-pc {
        @include max-media(990) {
          display: none;
        }
      }

      &-mobile {
        @include min-media(991) {
          display: none;
        }
      }
    }

    &__box {
      @include min-media(991) {
        @include grid(12, 12);
        grid-column: 1 / span 12;
      }

      @include max-media(990) {
        display: flex;
        flex-direction: column;
      }

      &__right {
        padding-left: toRem(20);

        @include min-media(991) {
          grid-column: 8 / span 5;
        }
      }
    }

    &__pic {
      border-radius: 0 0 toRem(500) toRem(500);
      overflow: hidden;

      @include min-media(991) {
        grid-column: 1 / span 7;
      }
    }

    &__title {
      margin-bottom: toRem(14);
    }

    &__text {
      margin-bottom: toRem(15);

      @include max-media(990) {
        margin-bottom: 20px;
      }
    }
  }

  &__card3 {
    grid-area: c;

    @include min-media(991) {
      margin-top: -10%;
    }
  }
}
</style>
